import React from "react";
import AdminLayout from "./AdminLayout";
import SubscriptionsManagement from "./SubscriptionsManagement";


function Subscriptions() {
    return (
        <AdminLayout>
            <SubscriptionsManagement />
        </AdminLayout>
    );
}

export default Subscriptions;
